import {
  areRandomEventsEnabled,
  type MapDefinitionFile,
  type MapTimelineBeat,
  type WorldMapScenario,
} from "./mapDefinition.ts";

export type { WorldMapScenario, MapDefinitionFile, MapTimelineBeat };
export { areRandomEventsEnabled } from "./mapDefinition.ts";

export interface TurnAdvancementPlan {
  allowNewActivations: boolean;
  beatsForEndedTurn: MapTimelineBeat[];
  activationTurn: number;
}

export function planTurnAdvancement(
  mapScenario: WorldMapScenario | null | undefined,
  playingTurnEnded: number,
  activationTurn: number,
): TurnAdvancementPlan {
  const scenario = mapScenario ?? null;
  const allowNewActivations =
    scenario === null || areRandomEventsEnabled(scenario);
  const timeline = scenario?.timeline;
  const beatsForEndedTurn =
    timeline && timeline.length > 0
      ? timeline.filter((beat) => beat.atTurn === playingTurnEnded)
      : [];

  return {
    allowNewActivations,
    beatsForEndedTurn,
    activationTurn,
  };
}
